// extracted by mini-css-extract-plugin
export default {"paymentSummary":"Summary_paymentSummary__LSoVZ","paymentSummaryHeader":"Summary_paymentSummaryHeader__vu-xR","boldText":"Summary_boldText__66Z-k"};